import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "push" }, null, -1)
const _hoisted_4 = {
  key: 1,
  class: "centered-page"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Sidebar = _resolveComponent("Sidebar")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_Header = _resolveComponent("Header")!
  const _component_AgRoleBanner = _resolveComponent("AgRoleBanner")!
  const _component_Title = _resolveComponent("Title")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Footer = _resolveComponent("Footer")!
  const _component_Page403 = _resolveComponent("Page403")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.checkRole)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", {
            class: _normalizeClass(["default-layout wrapper", 'ag-sidebar_' + _ctx.sidebarStatus])
          }, [
            _createVNode(_component_Sidebar, { items: _ctx.sidebarItems }, null, 8, ["items"]),
            _createElementVNode("main", _hoisted_2, [
              (_ctx.loader)
                ? (_openBlock(), _createBlock(_component_Loader, { key: 0 }))
                : _createCommentVNode("", true),
              _createVNode(_component_Header),
              (_ctx.showRoleBanner)
                ? (_openBlock(), _createBlock(_component_AgRoleBanner, {
                    key: 1,
                    "current-role": _ctx.currentRole,
                    showLinkedIcon: _ctx.showLinkedIcon,
                    templatePolicy: _ctx.templatePolicy
                  }, null, 8, ["current-role", "showLinkedIcon", "templatePolicy"]))
                : _createCommentVNode("", true),
              _createVNode(_component_Title),
              _createVNode(_component_router_view)
            ]),
            _hoisted_3
          ], 2),
          _createVNode(_component_Footer)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_Page403)
        ]))
  ]))
}